import React, { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../services/firebase';
import UserBadge from './UserBadge';

/**
 * A wrapper around UserBadge that listens for real-time updates to the user's tier.
 * @param {string} userId - The ID of the user to listen to.
 * @param {string} initialTier - The initial tier to display while loading/connecting.
 * @param {number} size - Size of the badge.
 */
const LiveUserBadge = ({ userId, initialTier, size = 16 }) => {
    const [tier, setTier] = useState(initialTier || 'global');

    useEffect(() => {
        if (!userId) return;

        // Subscribe to specific user document
        const unsub = onSnapshot(doc(db, 'users', userId), (docSnap) => {
            if (docSnap.exists()) {
                const data = docSnap.data();
                if (data.subscriptionTier) {
                    setTier(data.subscriptionTier);
                }
            }
        }, (error) => {
            console.error("Error listening to user badge:", error);
        });

        return () => unsub();
    }, [userId]);

    return React.createElement(UserBadge, { tier: tier, size: size });
};

export default LiveUserBadge;
